import { z } from "zod/v4";
import { libraryChangeSchema } from "../../../../agents/library-management/schema";
import { AgenticSettingsReviewOpType } from "../../types";

const operation = z.object({
  op_type: z.literal(AgenticSettingsReviewOpType.ManageLibraryAsset),
  change: libraryChangeSchema,
});

export const LIBRARY_MANAGEMENT_WIRE_OPERATIONS = [operation] as const;
export const LIBRARY_MANAGEMENT_STORED_OPERATIONS = [
  operation.extend({
    job_id: z.uuid().optional(),
  }),
] as const;
